import Vue from "vue";
import _ from "lodash";
import qs from "qs";
import moment from "moment";

const URL = "/db/client";
const API_URL = URL + "/api/";

const state = {
  client: [],
  client_loaded: false,
  client_init: true
};

const getters = {
  clientInjected(state) {
    return _.cloneDeep(state.client).map(data => {
      data.total_training = data.training.length;
      return data;
    });
  },
  clientByLaman(state, getters, rootState) {
    return state.client.filter(c => c.id_laman == rootState.id_laman$);
  },
  clientByPeriode(state, getters, rootState) {
    let client = _.cloneDeep(state.client);
    return client.map(data => {
      data.training = data.training.filter(tr => {
        let bool = true;
        if (moment(rootState.periode$).isValid()) {
          bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
        }
        return bool;
      });
      data.total_training = data.training.length;
      return data;
    });
  },
  clientByLamanPeriode(state, getters, rootState) {
    let client = _.cloneDeep(
      state.client.filter(c => c.id_laman == rootState.id_laman$)
    );
    return client.map(data => {
      let training = data.training.filter(tr => {
        let bool = true;
        if (moment(rootState.periode$).isValid()) {
          bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
        }
        return bool;
      });
      data.total_training = training.length;
      return data;
    });
  }
};

const mutations = {
  INIT(state) {
    if (state.client_init) state.client_init = false;
  },
  LOADED(state, payload) {
    state.client_loaded = payload;
  },
  SET_CLIENT(state, payload) {
    state.client = payload;
  },
  ADD_CLIENT(state, payload) {
    state.client.push(payload);
  },
  UPDATE_CLIENT(state, payload) {
    state.client = _.unionBy([payload], state.client, "id_client");
  },
  DELETE_CLIENT(state, ids) {
    _.remove(state.client, function(client) {
      return ids.includes(client.id_client);
    });
    state.client = [...state.client];
  }
};

const actions = {
  GET_OPTIONS({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(URL + "/options").then(res => {
      commit("laman/SET_LAMAN", res.data.laman, { root: true });
      commit("area/SET_AREA", res.data.area, { root: true });
      commit("LOADING_DONE", null, { root: true });
    });
  },
  GET_CLIENT({ commit }) {
    commit("LOADING", null, { root: true });
    commit("LOADED", false);
    return Vue.axios.get(API_URL).then(res => {
      commit("INIT");
      commit("LOADED", true);
      commit("SET_CLIENT", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  ADD_CLIENT({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL, qs.stringify(payload))
      .then(res => {
        commit("ADD_CLIENT", res.data);
        commit("SUCCESS", "Berhasil menambah...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  UPDATE_CLIENT({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .put(API_URL + payload.id_client, qs.stringify(payload))
      .then(res => {
        commit("UPDATE_CLIENT", res.data);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  DELETE_CLIENT({ commit }, payload) {
    let ids = payload.map(p => p.id_client).join(",");
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .delete(API_URL + ids)
      .then(res => {
        commit("DELETE_CLIENT", res.data.ids);
        if (typeof res.data.errors !== "undefined")
          commit("ERROR", res.data.errors, { root: true });
        else commit("SUCCESS", "Berhasil menghapus...", { root: true });
        return res.data.ids;
      })
      .catch(() => {
        commit("ERROR", "Data masih dipakai di tabel lain!", {
          root: true
        });
      });
  },
  MERGE_CLIENT({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(URL + "/merge/", qs.stringify(payload))
      .then(res => {
        commit("DELETE_CLIENT", res.data.ids);
        commit("UPDATE_CLIENT", res.data.destination);
        commit("SUCCESS", "Berhasil merge...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
